import {makeStyles} from '@material-ui/styles';
import {merge} from 'helpers/styles';

export default makeStyles((theme) => ({
        'root': merge({
                width: '100%',
                textAlign: 'center',
                color: theme.palette.common.white,
            },
            theme.gutter.md.margin.bottom,
        ),
        '__title': merge({
                color: theme.palette.common.white,
            },
            theme.gutter.xs.margin.bottom,
        ),
        '__text': merge({
                color: theme.palette.common.white,
            },
            theme.gutter.sm.margin.bottom,
        ),
    }),
    {
        name: 'CallToAction',
    },
);
